// extracted by mini-css-extract-plugin
module.exports = {"CartItemsCounter":"CartIconContainer_CartItemsCounter__2Czlv"};